import { Helper } from '../Helper';
export class ArrFilterHelper extends Helper {
    constructor(options) {
        super();
        this.map = options.map;
        this.withIndex = options.withIndex || false;
    }
    emit(sb, node, options) {
        const handleResult = (innerOptions) => {
            sb.emitHelper(node, innerOptions, sb.helpers.if({
                condition: () => {
                    this.map(innerOptions);
                },
                whenTrue: () => {
                    sb.emitOp(node, 'TUCK');
                    sb.emitOp(node, 'SWAP');
                    sb.emitOp(node, 'APPEND');
                },
                whenFalse: () => {
                    sb.emitOp(node, 'NIP');
                },
            }));
        };
        if (this.withIndex) {
            sb.emitSysCall(node, 'Neo.Iterator.Create');
            sb.emitPushInt(node, 0);
            sb.emitOp(node, 'NEWARRAY');
            sb.emitHelper(node, options, sb.helpers.rawIteratorReduce({
                each: (innerOptions) => {
                    sb.emitOp(node, 'ROT');
                    sb.emitOp(node, 'TUCK');
                    sb.emitPushInt(node, 3);
                    sb.emitOp(node, 'ROLL');
                    sb.emitOp(node, 'SWAP');
                    handleResult(innerOptions);
                },
            }));
        }
        else {
            sb.emitSysCall(node, 'Neo.Enumerator.Create');
            sb.emitPushInt(node, 0);
            sb.emitOp(node, 'NEWARRAY');
            sb.emitHelper(node, options, sb.helpers.rawEnumeratorReduce({
                each: (innerOptions) => {
                    sb.emitOp(node, 'OVER');
                    handleResult(innerOptions);
                },
            }));
        }
    }
}

//# sourceMappingURL=ArrFilterHelper.js.map
